// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PorterGoldDetailsApiModel from "../api-model/PorterGoldDetailsApiModel.bs.js";

function execute(json) {
  var json$1 = DeccoUtils$Catalyst.resolveResult(PorterGoldDetailsApiModel.t_decode(json), "PorterGoldDetailsEntityMapper.re");
  return {
          message: Belt_Option.getWithDefault(json$1.status, "")
        };
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
